var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('eco-labeled-control',{attrs:{"context":_vm.context,"attributes":_vm.attributes}},[_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.currentValue))])])])}
var staticRenderFns = []

export { render, staticRenderFns }